import tasks from './tasks';
import biz from './biz';
import users from './users';
import ops from './ops';
import chat from './chat';
import auth from './auth';
import newbie from './newbie';

const MODULES = [tasks, biz, users, ops, chat, auth, newbie];
const LANGS = ['vi', 'en', 'ko', 'ja', 'zh'];

// Admin-page translations live here (one module per page group) so page work
// never touches the base LocaleContext dictionary.
const merged = {};
for (const lang of LANGS) {
  merged[lang] = Object.assign({}, ...MODULES.map((m) => m[lang] || {}));
}

export default merged;
